// @flow
import * as React from "react";
import { Heading, Box, Flex, Subhead, Image } from "rebass";
import styled from "styled-components";
import omit from "lodash.omit";

import IntroPart1 from "./IntroPart1";
import IntroPart2 from "./IntroPart2";
import IntroPart3 from "./IntroPart3";
import IntroPart4 from "./IntroPart4";
import Circle from "../../components/ui/Circle";

type Props = {
  siteMetadata: { appUrl: string }
};

const propsToOmit = ["siteMetadata"];

const Intro = (props: Props) => (
  <StyledBox {...omit(props, propsToOmit)}>
    <div className="container">
      <Flex mx="auto" wrap>
        <IntroPart1 {...props} />
        <IntroPart2 {...props} />
        <IntroPart3 {...props} />
        <IntroPart4 {...props} />
      </Flex>
    </div>
  </StyledBox>
);

export default Intro;

// Styled Components
const StyledBox = styled(Box)`
  position: relative;

  &:before {
    -ms-transform: skewY(3deg);
    background: #f8fcff;
    border: 1px solid rgba(151, 151, 151, 0.06);
    box-shadow: 0 0 20px 0 rgba(0, 0, 0, 0.08);
    content: "";
    display: block;
    height: 100%;
    position: absolute;
    top: 0;
    transform: skewY(3deg);
    width: 100%;
    z-index: 0;
    z-index: 1;
  }

  .container {
    position: relative;
    z-index: 2;
  }
`;


// WEBPACK FOOTER //
// ./src/components/Intro/Intro.jsx